// Copyright (c) 2016 Deere & Company

import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import {
    isLengthAtLeast,
    isLengthWithinRange
} from '../../../shared/services/validation-service';
import {translate} from '../../../shared/services/translation-service';

const validateClaimType = queryString => {

    const claimTypeMaxLength = 9;
    const claimTypeMinLength = 4;

    return isLengthWithinRange(queryString, claimTypeMaxLength, claimTypeMinLength);

};

const validateClaim = queryString => {

    const claimMaxLength = 9;
    const claimMinLength = 4;

    return isLengthWithinRange(queryString, claimMaxLength, claimMinLength);

};

const validateWorkOrder = queryString => {

    const workOrderMinLength = 2;

    return isLengthAtLeast(queryString, workOrderMinLength);

};

const validateFailurePartNumber = queryString => {

    const workOrderMinLength = 4;

    return isLengthAtLeast(queryString, workOrderMinLength);

};

const validatePin = queryString => {

    const pinMaxLength = 17;
    const pinMinLength = 6;

    return isLengthWithinRange(queryString, pinMaxLength, pinMinLength);

};

export const mapClaimValidation = (key, queryString) => {

    const map = {
        CLAIM: validateClaim,
        CLAIM_TYPE: validateClaimType,
        FAILURE_PART: validateFailurePartNumber,
        PIN: validatePin,
        WORK_ORDER: validateWorkOrder
    };

    return map[key](queryString);

};

export const mapSearchPlaceHolder = key => {

    const map = {
        CLAIM: 'SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER',
        CLAIM_TYPE: 'SEARCH_BY_CLAIM_TYPE',
        FAILURE_PART: 'SEARCH_BY_FAILURE_PART_NUMBER',
        PIN: 'SEARCH_PRODUCT_BY_PIN_PLACEHOLDER',
        WORK_ORDER: 'SEARCH_BY_WORK_ORDER'
    };

    return map[key];

};

export const mapValidationErrorMessages = key => {

    const map = {
        CLAIM: 'SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL',
        CLAIM_TYPE: 'SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL',
        FAILURE_PART: 'SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL',
        PIN: 'SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL',
        WORK_ORDER: 'SEARCH_BY_WORK_ORDER_VALIDATION_FAIL'
    };

    return map[key];

};

export const getClaimFacetOptions = () => [
    {
        key: 'APPROVED',
        value: translate('APPROVED')
    },
    {
        key: 'CREATED',
        value: translate('CREATED')
    },
    {
        key: 'SUBMITTED',
        value: translate('SUBMITTED')
    },
    {
        key: 'CHANGED',
        value: translate('CHANGED')
    }
];

export const showValidationError = (formatMessage, key) =>
    errorAlertBar(createErrorObject(formatMessage({
        id: key
    })));

export const getSortOptions = () => [
    {
        displayName: 'DEALER_LOCATION',
        path: [
            'responsibleAccount',
            'account'
        ]
    },
    {
        displayName: 'WORK_ORDER_ONE',
        path: [
            'referenceInfo',
            'referenceNumber1'
        ]
    },
    {
        displayName: 'WORK_ORDER_TWO',
        path: [
            'referenceInfo',
            'referenceNumber2'
        ]
    },
    {
        displayName: 'REPAIR_NUMBER',
        path: [
            'referenceInfo',
            'repairNumber'
        ]
    },
    {
        displayName: 'PIN',
        path: [
            'pin'
        ]
    },
    {
        displayName: 'CLAIM_NUMBER',
        path: [
            'claimNumber'
        ]
    },
    {
        displayName: 'CLAIM_TYPE',
        path: [
            'claimType',
            'value'
        ]
    },
    {
        displayName: 'SUB_CLAIM_TYPE',
        path: [
            'subClaimType',
            'value'
        ]
    },
    {
        displayName: 'CREATED',
        path: [
            'recordInfo',
            'createdDate'
        ]
    },
    {
        displayName: 'APPROVED',
        path: [
            'approvalDate'
        ]
    },
    {
        displayName: 'SUBMITTED',
        path: [
            'originalSubmissionDate'
        ]
    },
    {
        displayName: 'CHANGED',
        path: [
            'recordInfo',
            'updatedDate'
        ]
    },
    {
        displayName: 'CREDIT_MEMO',
        path: [
            'claimValueDetails',
            'creditMemoNumber'
        ]
    },
    {
        displayName: 'STATUS',
        path: [
            'claimStatus',
            'value'
        ]
    }
];

export const getAllClaimsSortOptions = () => [
    {
        displayName: 'DEALER_LOCATION',
        path: [
            'responsibleAccount',
            'account'
        ]
    },
    {
        displayName: 'WORK_ORDER_ONE',
        path: [
            'referenceInfo',
            'referenceNumber1'
        ]
    },
    {
        displayName: 'WORK_ORDER_TWO',
        path: [
            'referenceInfo',
            'referenceNumber2'
        ]
    },
    {
        displayName: 'REPAIR_NUMBER',
        path: [
            'referenceInfo',
            'repairNumber'
        ]
    },
    {
        displayName: 'PIN',
        path: [
            'pin'
        ]
    },
    {
        displayName: 'CLAIM_NUMBER',
        path: [
            'claimNumber'
        ]
    },
    {
        displayName: 'CLAIM_TYPE',
        path: [
            'claimType',
            'value'
        ]
    },
    {
        displayName: 'SUB_CLAIM_TYPE',
        path: [
            'subClaimType',
            'value'
        ]
    },
    {
        displayName: 'CREATED',
        path: [
            'recordInfo',
            'createdDate'
        ]
    },
    {
        displayName: 'CREATED_BY',
        path: [
            'recordInfo',
            'createdBy',
            'lastName'
        ]
    },
    {
        displayName: 'APPROVED',
        path: [
            'approvalDate'
        ]
    },
    {
        displayName: 'SUBMITTED',
        path: [
            'originalSubmissionDate'
        ]
    },
    {
        displayName: 'CHANGED',
        path: [
            'recordInfo',
            'updatedDate'
        ]
    },
    {
        displayName: 'CREDIT_MEMO',
        path: [
            'claimValueDetails',
            'creditMemoNumber'
        ]
    }
];

export const getFilterOptions = () => [
    [
        'pin'
    ],
    [
        'customerSummary',
        'displayName'
    ],
    [
        'responsibleAccount',
        'account'
    ],
    [
        'responsibleAccount',
        'name'
    ],
    [
        'responsibleAccount',
        'location',
        'city'
    ],
    [
        'claimStatus',
        'value'
    ],
    [
        'claimType',
        'value'
    ],
    [
        'subClaimType',
        'value'
    ],
    [
        'recordInfo',
        'createdBy',
        'firstName'
    ],
    [
        'recordInfo',
        'createdBy',
        'lastName'
    ],
    [
        'recordInfo',
        'createdBy',
        'id'
    ],
    [
        'referenceInfo',
        'referenceNumber1'
    ],
    [
        'referenceInfo',
        'referenceNumber2'
    ],
    [
        'failureInfo',
        'failurePartNumber'
    ],
    [
        'claimNumber'
    ]
];

const filterItemOnDealers = (accountNumber, selectedDealers) =>
    selectedDealers.some(item => item.account === accountNumber);

const filterItemOnKeyValueTypes = (itemToCompare, selectedItems) =>
    selectedItems.some(item => item.key === itemToCompare.key);

const mapDate = (key, item) => {

    const map = {
        APPROVED: item.approvalDate,
        CREATED: item.recordInfo.createdDate,
        SUBMITTED: item.originalSubmissionDate,
        UPDATED: item.recordInfo.updatedDate
    };

    return map[key];

};

const filterItemOnDateRange = (item, dateFilters) =>
    dateFilters.selectedDateRange.from <= mapDate(dateFilters.selectedDateType, item) && mapDate(dateFilters.selectedDateType, item) <= dateFilters.selectedDateRange.to;

const filters = item => ({
    dateFilter: filterItemOnDateRange.bind(null, item),
    selectedClaimStatus: filterItemOnKeyValueTypes.bind(null, item.claimStatus),
    selectedClaimTypes: filterItemOnKeyValueTypes.bind(null, item.claimType),
    selectedDealers: filterItemOnDealers.bind(null, item.responsibleAccount.account)
});

function filterForParams(params) {

    return item => Object.keys(params).reduce((currentStatus, key) => {

        const filterBy = filters(item)[key];
        const value = params[key];

        return currentStatus && filterBy(value);

    }, true);

}

export function filterSearchResults(searchResults, params) {

    return searchResults.filter(filterForParams(params));

}

export const groupClaimData = (claimStatus, searchResults) => {

    const groupedClaims = {};

    claimStatus.forEach(status => {

        groupedClaims[status.key] = searchResults.filter(result =>
            result.claimStatus.key === status.key
        );

    });

    return groupedClaims;

};

export const mapClaimStatus = key => {

    const map = {
        '01': 'CLAIM_DRAFT',
        1: 'NEW',
        10: 'REJECTED_APPEAL',
        12: 'DEALER_INVOICE_UPDATED',
        13: 'RECONCILED',
        14: 'SUBMITTED_AVAILABLE_TO_EDIT',
        15: 'DEBITED',
        16: 'SELECTED_FOR_AUDIT',
        2: 'SUBMITTED',
        3: 'APPROVED',
        4: 'REJECTED',
        5: 'DELETED',
        6: 'FORWARDED',
        7: 'RETURNED',
        8: 'REVISED',
        9: 'WAITING_FOR_DLR_INV'
    };

    return map[key];

};

export const getAccordionItem = (items, status) =>
    items.find(item => item.accordionId === mapClaimStatus(status));



// WEBPACK FOOTER //
// ./src/claim/shared/services/claim-search-helper.js